import { Controller } from "@hotwired/stimulus";

import { projects } from "~/api";

// Connects to data-controller="projects"
export default class extends Controller {
  static targets = ["tabPane"];

  connect() {
    document.getElementById("filter-form").reset();

    this.renderProjectsTable({ active: true }, "active");
  }

  selectTab({ target }) {
    const id = target.getAttribute("data-bs-target").replace("#", "");
    this.renderProjectsTable({ active: id === "active" }, id);
  }

  selectPage(event) {
    event.preventDefault();

    const url = event.currentTarget.href;
    const params = new URL(url).searchParams.entries();
    this.renderProjectsTable(Object.fromEntries(params), this.currentlyActiveTabPane().id);
  }

  filter(event) {
    event.preventDefault();

    const active = this.currentlyActiveTabPane().id === "active";
    const formData = new URLSearchParams(new FormData(event.target));
    const params = Object.fromEntries([...formData.entries(), ["active", active]]);
    this.renderProjectsTable(params, this.currentlyActiveTabPane().id);
  }

  renderProjectsTable(params, id) {
    projects
      .all({
        query: params,
        responseAs: "response",
        headers: { Accept: "text/html" }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}, ${response.statusText}`);
        }

        return response.text();
      })
      .then((html) => (this.tabPane(id).innerHTML = html))
      .catch((error) => this.renderAlert(id, error.message));
  }

  tabPane(id) {
    return this.tabPaneTargets.find((tabPane) => tabPane.id === id);
  }

  currentlyActiveTabPane() {
    return this.tabPaneTargets.find((tabPane) => tabPane.classList.contains("active"));
  }

  renderAlert(id, errorMessage = "Oops, something went wrong!") {
    const errorHtml = `
      <div class="alert alert-danger alert-dismissible fade show mt-3" role="alert" id="projects-fetch-alert">
        <strong>${errorMessage}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `;
    this.tabPane(id).innerHTML = errorHtml;

    const alert = document.getElementById("projects-fetch-alert");
    alert.addEventListener("closed.bs.alert", () => location.reload());
  }
}
